import type { Chain } from 'viem/chains';
import { switchChain, type SwitchChainParameters } from '../actions/switchChain';
import { useContext } from '../context';
import { useMutation, type MutationOptions } from './useMutation';

export type UseSwitchChainParameters = MutationOptions<Chain, SwitchChainParameters>;

export const useSwitchChain = (parameters?: UseSwitchChainParameters) => {
  const { config } = useContext();

  const mutationFn = async (parameters: SwitchChainParameters) => {
    return await switchChain(config, parameters);
  };

  const { status, data, error, mutate, mutateAsync } = useMutation(mutationFn, parameters);

  return {
    status,
    data,
    error,
    switchChain: mutate,
    switchChainAsync: mutateAsync,
  };
};
